import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Narrow Gate Training - Elite Basketball Training & Character Development',
  description = 'Transform your game with Narrow Gate Training. Expert basketball training, skill development, and character building programs. Enter through the narrow gate to unlock your full potential.',
  keywords = 'narrow gate path, narrow gate training, basketball training, skill development, character building, elite training, sports performance',
  canonicalUrl = 'https://narrowgatetraining.com'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Schema.org markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SportsOrganization",
          "name": "Narrow Gate Training",
          "description": description,
          "url": canonicalUrl,
          "sameAs": [
            "https://www.instagram.com/narrowgatetraining",
            "https://www.facebook.com/narrowgatetraining"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
